import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Spinner } from '@wellbeingxltd/fe-lib/components'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { IoCheckmarkCircleOutline, IoEllipsisHorizontalCircle } from 'react-icons/io5'
import SupplierActions from 'store/models/supplier'
import styles from './Shopify.module.scss'

export const IntegrationStatus = () => {
    const dispatch = useDispatch()
    const {
        shopifyProductsCount = 0,
        shopifyProductsCountError,
        loadingGetShopifyProductsCount = true,
        shopifyDetails: { shopifyProductsLinked },
    } = useSelector(GET_STORE.SUPPLIER)
    const { supplierId } = JSON.parse(localStorage.getItem('supplier'))

    useEffect(() => dispatch(SupplierActions.getShopifyProductsCount(supplierId)), [])

    const completedStep = +localStorage.getItem('completedStep')
    const isShopifyNotConnected = shopifyProductsCountError === 'Suppliers shopify details not found'
    const inProgress = completedStep > 0

    const FirstStatus = loadingGetShopifyProductsCount ? null : !isShopifyNotConnected ? (
        <div className={styles.statusBlock}>
            <IoCheckmarkCircleOutline className={styles.icon + ' ' + styles.green} size="30px" />
            <span testid="shopifyStatus">Shopify setup: Integration complete</span>
        </div>
    ) : inProgress ? (
        <div className={styles.statusBlock}>
            <IoEllipsisHorizontalCircle className={styles.icon + ' ' + styles.yellow} size="30px" />
            <span testid="shopifyStatus">Shopify setup: In progress</span>
        </div>
    ) : (
        <div className={styles.statusBlock}>
            <IoEllipsisHorizontalCircle className={styles.icon + ' ' + styles.grey} size="30px" />
            <span testid="shopifyStatus">Shopify setup: Not yet integrated</span>
        </div>
    )

    const SecondStatus = loadingGetShopifyProductsCount ? null : !isShopifyNotConnected ? (
        shopifyProductsLinked >= 1 ? (
            <div className={styles.statusBlock}>
                <IoCheckmarkCircleOutline className={styles.icon + ' ' + styles.green} size="30px" />
                <span testid="shopifyLinkStatus">
                    Link <Link to={'/directory'}>directory</Link>: {shopifyProductsLinked}/{shopifyProductsCount} product
                    {shopifyProductsLinked > 1 && 's'} linked
                </span>
            </div>
        ) : (
            <div className={styles.statusBlock}>
                <IoEllipsisHorizontalCircle className={styles.icon + ' ' + styles.yellow} size="30px" />
                <span testid="shopifyLinkStatus">
                    Link <Link to={'/directory'}>directory</Link>: 0/{shopifyProductsCount} products linked
                </span>
            </div>
        )
    ) : (
        <div className={styles.statusBlock}>
            <IoEllipsisHorizontalCircle className={styles.icon + ' ' + styles.grey} size="30px" />
            <span testid="shopifyLinkStatus">Link directory: Not yet integrated</span>
        </div>
    )

    return (
        <div className={`module ${styles.IntegrationStatus}`}>
            <div className="module-header">
                <h2>Integration Status</h2>
            </div>
            {loadingGetShopifyProductsCount && <Spinner color={'var(--grey-med)'} />}

            {
                <>
                    {FirstStatus}
                    {SecondStatus}
                </>
            }
        </div>
    )
}
